"use strict";
/**
 * @author Maxim Seredkin
 */
export default function () {
  return {
    restrict: "A",
    template: require("../view/project-gchp-table-row.html"),
    transclude: true,
    scope: {
      onVisible: "=onVisible",
      project: "=myProject",
      openEditProject: "=openEditProject",
    },
    controller: [
      "$scope",
      "OrgService",
      "OperatorService",
      "ChartOptionsService",
      "ProjectGchpService",
      function (
        $scope,
        OrgService,
        OperatorService,
        ChartOptionsService,
        ProjectGchpService
      ) {
        $scope.infoItems = makeInfoItems($scope.project);
        $scope.onClickViewProject = () => {
          ProjectGchpService.edit($scope.project.id);
        };
        $scope.calcDashArrayValue = (r) => {
          const length = 2 * Math.PI * r;
          const percent = $scope.project.phase
            ? $scope.project.phase.percent
            : 0;
          return [length, length - (length * percent) / 100];
        };
        $scope.getPlanPeriod = () =>
          $scope.project.planStartDate || $scope.project.planEndDate
            ? [$scope.project.planStartDate, $scope.project.planEndDate].join(
                " - "
              )
            : "Нет данных";
        $scope.getTotalFunds = () =>
          $scope.project.planFundsTotal
            ? `${round($scope.project.planFundsTotal)} млн руб.`
            : "Нет данных";
        $scope.getOutFunds = () =>
          $scope.project.planFundsOutside
            ? `${round($scope.project.planFundsOutside)} млн руб.`
            : "Нет данных";
        $scope.activeWidget = 1;
        $scope.widgets = {
          1: "О ГЛАВНОМ",
          2: "ОБЪЕМ ИНВЕСТИРОВАНИЯ",
        };
        function round(num) {
          return Math.round(num * 1000.0) / 1000.0;
        }
        $scope.activeBudget = 1;
        $scope.planFundSeries = ["Объем инвестиций"];
        $scope.planFundOptions = ChartOptionsService.getBarChartOptions({
          yAxeType: "logarithmic",
          hideLegend: true,
          hideTitle: true,
          unit: "млн руб.",
          removeYAxe: true,
        });
        $scope.getCurrentBudgetData = (activeBudget) => {
          if (activeBudget === 1) {
            return $scope.project.projectPlanFundsDataFederal;
          }
          if (activeBudget === 2) {
            return $scope.project.projectPlanFundsDataMunicipal;
          }
          if (activeBudget === 3) {
            return $scope.project.projectPlanFundsDataLocal;
          }
        };
        $scope.barColors = ["#3C8DBC"];

        function makeInfoItems(project) {
          return [
            {
              title: "Реквизиты",
              value: $scope.project.concessionAgreement || "Нет данных",
            },
            {
              title: "Публичная сторона",
              value: $scope.project.concessor
                ? $scope.project.concessor.shortName
                : "Нет данных",
            },
            {
              title: "Частная сторона",
              value: $scope.project.author
                ? $scope.project.author.shortName
                : "Нет данных",
            },
            {
              title: "Основание",
              value: $scope.project.agreementReason || "Нет данных",
            },
            {
              title: "Вид эконом. деятельности",
              value:
                Array.isArray($scope.project.projectOkveds) &&
                $scope.project.projectOkveds.length
                  ? $scope.project.projectOkveds.map((n) => n.code).join(", ")
                  : "Нет данных" || "Нет данных",
            },
            {
              title: "Место реализации проекта",
              value: $scope.project.placesMunicipality
                ? $scope.project.placesMunicipality
                    .map((item) => item.name)
                    .join(", ")
                : "Нет данных",
            },
          ];
        }

        $scope.$watch("project", () => {
          $scope.infoItems = makeInfoItems($scope.project);
        });
      },
    ],
  };
}
